<template>
  <article>
    <MastheadAlt
      title="Media Kit"
      text="Hello! We're Campsite.bio, a link in bio tool that has been around since 2017."
      :profile-images="[
        '/campsites/creators/campsite-beccajamesuk.png',
        '/campsites/creators/campsite-cassierandolph.png',
        '/campsites/creators/campsite-chrisbethea.png',
        '/campsites/creators/campsite-copycompass.png',
        '/campsites/creators/campsite-dothedamnthing.png',
        '/campsites/creators/campsite-gisellemays.png',
        '/campsites/creators/campsite-jamiebareno.png',
        '/campsites/creators/campsite-heyjessica.png',
        '/campsites/creators/campsite-organicallybecca.png',
        '/campsites/creators/campsite-thewinestylings.png',
        '/campsites/creators/campsite-artisiq.png',
        '/campsites/creators/campsite-alexokoroji.png',
        '/campsites/creators/campsite-mattevans.png',
        '/campsites/creators/campsite-adionnewilliams.png',
      ]"
    />

    <FeatureSection title="Campsite.bio Assets">
      <FeatureCard title="Logos">
        <VText
          >Please don't modify the marks or logos or use them in a confusing
          way.
        </VText>
        <InlineLink
          slot="actions"
          href="https://cdn.campsite.bio/media-kit/logos.zip"
          download
        >
          Download&nbsp;<FileDownloadIcon />
        </InlineLink>
      </FeatureCard>
      <!-- <FeatureCard title="Product screenshots">
        <VText
          >Need some screenshots? We've got you. Get high-resolution assets of
          the Campsite.bio interface on desktop, mobile and tablet.
        </VText>
        <InlineLink
          slot="actions"
          href="https://cdn.campsite.bio/media-kit/product-screenshots.zip"
          download
        >
          Download&nbsp;<FileDownloadIcon />
        </InlineLink>
      </FeatureCard> -->
      <FeatureCard title="Leadership photos">
        <VText>Here you'll find photos of our leadership team. </VText>
        <InlineLink
          slot="actions"
          href="https://cdn.campsite.bio/media-kit/leadership-photos.zip"
          download
        >
          Download&nbsp;<FileDownloadIcon />
        </InlineLink>
      </FeatureCard>
    </FeatureSection>

    <div class="color-blocks grid grid--container">
      <VText variant="h2">Our Brand Colors</VText>
      <div class="color-blocks__grid">
        <ColorBlock v-for="color in colors" :key="color" :value="color" />
      </div>
    </div>
  </article>
</template>

<script>
import {
  VText,
  InlineLink,
  FileDownloadIcon,
  useTheme,
} from '@campsite-bio/component-lib';
import { computed } from '@nuxtjs/composition-api';

import { generateMeta } from '@/utils/generate-meta';
import MastheadAlt from '@/components/sections/masthead-alt';
import FeatureCard from '@/components/features/feature-card';
import FeatureSection from '@/components/features/feature-section';
import ColorBlock from '@/components/color-block';

export default {
  components: {
    VText,
    InlineLink,
    FileDownloadIcon,
    MastheadAlt,
    FeatureCard,
    FeatureSection,
    ColorBlock,
  },

  head() {
    return generateMeta({
      title: 'Media Kit for Campsite.bio',
      description:
        'A link in bio tool created just for you. Use our free landing page tool to create your own space on the web. Turn your followers into conversions.',
    });
  },

  setup() {
    const theme = useTheme();

    const colors = computed(() => {
      const {
        primary,
        lightBlue,
        darkGreen,
        lightGreen,
        orange,
        yellow,
        black,
      } = theme.value.colors;
      return [primary, darkGreen, lightGreen, lightBlue, orange, yellow, black];
    });

    return {
      colors,
    };
  },
};
</script>

<style lang="scss" scoped>
.color-blocks {
  text-align: center;

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    grid-gap: 1rem;
    padding-bottom: 4rem;
    padding-top: 2.5rem;
  }
}
</style>
